import { importProvidersFrom, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserState } from '../state/user/user-state';
import { NgxsModule } from '@ngxs/store';
import { ApiModule } from './api.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ApiModule
  ],
  providers:[
    importProvidersFrom(
      NgxsModule.forRoot([UserState])
    )
  
  ]
})
export class UserModule { }
